module.exports = __webpack_public_path__ + "static/media/sectur02.d1639052.png";